import { render } from "./JobSeekerList.vue?vue&type=template&id=eee87ebc&scoped=true"
import script from "./JobSeekerList.vue?vue&type=script&lang=js"
export * from "./JobSeekerList.vue?vue&type=script&lang=js"

import "./JobSeekerList.vue?vue&type=style&index=0&id=eee87ebc&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eee87ebc"]])

export default __exports__